
import Bugsnag from '@bugsnag/js';

export enum ParsedJsonEnum {
  error = 'error',
  success = 'success',
  empty = 'empty',
}

type ParsedJsonResult<DataType = object> = {
  status: ParsedJsonEnum.success;
  data: DataType;
} | {
  status: ParsedJsonEnum.error;
  data: null;
} | {
  status: ParsedJsonEnum.empty;
  data: null;
};

export const onParseJson = <DataType = object>(json?: string): ParsedJsonResult<DataType> => {
  if (!json) {
    return {
      status: ParsedJsonEnum.empty,
      data: null,
    };
  }
  try {
    return {
      status: ParsedJsonEnum.success,
      data: JSON.parse(json) as DataType,
    };
  } catch {
    return {
      status: ParsedJsonEnum.error,
      data: null,
    };
  }
};

export const formatJsonLabel = (key: string | number): string => `${key}`
  .replace(/_/g, ' ')
  .replace(/([A-Z])/g, ' $1')
  .replace(/^./, (str) => str.toUpperCase())
  .trim();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toJSON = <T = any>(data?: string, report = true): T | undefined => {
  if (!data || typeof data !== 'string') {
    return undefined;
  }
  try {
    const json = JSON.parse(data);
    return json;
  } catch (error) {
    if (report) {
      Bugsnag.notify(error as Error);
    }
    return undefined;
  }
};
